/* eslint-disable indent */
import normalAxios from 'axios';
import qs from 'qs';
import { httpRequest, request } from '../request';
import type { ApiParamsDefinition } from '../types/api-definition';

const common = {
  // 全局配置（落地页，全部加载使用）
  bffPcGlobal: (data: ApiParamsDefinition['POST:/api/bff/pc_global']) =>
    httpRequest('POST:/api/bff/pc_global', data),
  // 常用国家列表
  commonCountry: (data: any) => request('/api/public/common_country', 'get', data),
  // 所有国家列表
  countryList: () => request('/api/public/country', 'get', {}),
  // 根据 ip 获取国家
  ipCountry: () => request('/api/public/ip_country', 'get', {}),
  recommend: (data: any) => request('/api/public/recommend_products', 'get', data), // 获取各个版块的推荐
  // 根据sku获取试戴数据
  tryOn: (data: any) => {
    return normalAxios.post('https://tryon.nextmar.com/api/tryon/get_sku_info', qs.stringify(data));
  },
  /* 试戴上传图片并获取定位信息 */
  uploadTryOnImg: (data: any) => {
    return normalAxios.post(
      'https://tryon.nextmar.com/api/tryon/photo_upload_base64',
      qs.stringify(data),
    );
  },
  // 试戴上传（参数为文件格式）
  uploadTryOnImgFile: (data: any) => {
    return normalAxios.post('https://tryon.nextmar.com/api/tryon/photo_upload_form', data);
  },
  getSmsLink: (data: any) => request('/api/public/get_sms_link', 'get', data), // 获取短信链列表
  setCj: (data: any) => request('/api/customer/set_cj_assigned', 'post', data), // 检测到cj标识（保存30天），且用户登录，则传给接口，让app使用
  klarnaSave: () => request('/api/public/get_reduce_for_klarna_pay', 'get', {}), // klarna 支付优惠
  // 获取用户版本信息
  getVersion: () => {
    const t = Date.now();
    return normalAxios(`/version.json?t=${t}`);
  },
  // 根据utm参数领取优惠券
  getCouponUtm: (data: any) =>
    request('/api/customer/get_coupon_utm', 'post', data, {
      successMsg: false,
      errorMsg: true,
    }),
  // 日志收集
  collectError: (data: any) => request('/api/public/collect_error', 'post', data),
  // 邮件退订
  emailUnsubscribe: (data: any) => request('/api/customer/unsubscribe_email', 'post', data),
  // 删除账户发送验证码
  logOffSendCode: (data: any) =>
    request('/api/customer/log_off_send_code', 'post', data, {
      successMsg: false,
      errorMsg: true,
    }),
  // 删除账户
  logOff: (data: any) =>
    request('/api/customer/log_off', 'post', data, { successMsg: false, errorMsg: true }),
  // 绑定impact
  bindImpact: (data: any) =>
    request('/api/customer/bind_impact', 'get', data, { successMsg: false, errorMsg: false }),
  // 绑定awin
  bindAwin: (data: any) =>
    request('/api/customer/bind_awin', 'get', data, { successMsg: false, errorMsg: false }),
  /* 获取contact-us主题列表的数据 */
  getContactUsSubjectList: (data: any) =>
    request('/api/public/contact_us_subject/lists', 'get', data),
  // 获取后台配置jsonvalue
  getBlockValue: (data: any) => request('/api/block_config/get_block_value', 'post', data),

  // webpush 神策-灰度策略
  webPushGrayscaleStrategy: () => request('/api/public/sensors/grayscale_strategy'),
  // 通用配置接口（接口根据传参返回对应数据）
  getPublicResources: (data: any) => request('/api/public/resources', 'post', data),
  filterStatistics: (data: any) => request('/api/products/filter_statistics', 'post', data),
  getABTest: (data: any) => request('/api/ab_test', 'get', data), // 全局AB测试接口
  // WriteForUs提交接口
  writeForUsApplication: (data: any) =>
    request('/api/write_for_us/create', 'post', data, {
      successMsg: true,
      errorMsg: true,
    }),
};
export default common;
